import useBreakpoint from '@utils/useBreakpoint';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SortByOption from './SortByOption';
const SortBy = (props) => {
    const { productSort, sortingExpanded, currentSortOption, toggleSort, sortItems, fromSearch } = props;
    const { t } = useTranslation();
    const [focusedOption, setFocusedOption] = useState();
    const currentBreakpoint = useBreakpoint();
    const isDesktop = useMemo(() => {
        return currentBreakpoint >= window.mqObj.md;
    }, [currentBreakpoint]);
    useEffect(() => {
        if (sortingExpanded) {
            setFocusedOption(0);
        }
        else {
            setFocusedOption(undefined);
        }
    }, [sortingExpanded]);
    const focusOption = (dir) => {
        if (dir == 'next') {
            setFocusedOption(focusedOption + 1 < productSort.options.length ? focusedOption + 1 : focusedOption);
        }
        else {
            setFocusedOption(focusedOption - 1 <= 0 ? 0 : focusedOption - 1);
        }
    };
    const sortingHandler = (forceHide) => {
        toggleSort(forceHide);
        // HOVER EVENTS REMOVAL ON PLP FILTERS [OE-15483]
        // if (!sortingExpanded) {
        //   fromSearch ? analytics.searchSortOpen() : analytics.sortOpen();
        // }
    };
    return (React.createElement("div", { className: "sort", onMouseEnter: () => {
            if (isDesktop) {
                sortingHandler(false);
            }
        }, onMouseLeave: () => {
            if (isDesktop) {
                sortingHandler(true);
            }
        } },
        React.createElement("button", { "aria-haspopup": "listbox", id: "sortButton", className: "filters__menuitem sort__button", onKeyDown: (e) => {
                if ((sortingExpanded && e.key == 'Tab') || e.key == 'ArrowDown') {
                    e.preventDefault();
                    toggleSort(false);
                }
            }, "aria-expanded": sortingExpanded, onClick: () => {
                sortingHandler(false);
            } },
            t('refine.sortby'),
            " ",
            React.createElement("span", null, currentSortOption === null || currentSortOption === void 0 ? void 0 : currentSortOption.displayName)),
        React.createElement("div", { className: "sort__list--wrapper" },
            React.createElement("ul", { id: "exp_elem_list", role: "listbox", "aria-labelledby": "sortButton", className: "none sort__list" }, productSort === null || productSort === void 0 ? void 0 : productSort.options.map((option, i) => (React.createElement(SortByOption, { key: i, index: i, option: option, currentSortOption: currentSortOption, sortItems: sortItems, toggleSort: () => toggleSort(false), fromSearch: fromSearch, focusOption: focusOption, focusedOption: focusedOption })))))));
};
export default SortBy;
